import {
	ArrayPick,
	ClassNameProps,
	Column,
	If,
	makeClassName,
	Modal,
	Row,
	StyleProps,
	TruncatedText,
} from "@hex-insights/core";
import { Announcement, User, UserNameAndImageFragment } from "../../../../Utilities";
import { AuthorTimestampView as GeneralAuthorTimestampView } from "../../_General/Author";
import * as MediaAttachmentComponents from "../../MediaAttachment";
import { AnnouncementModal, AnnouncementModalProps } from "../Modal";
import styles from "./styles.module.css";

export type CardAnnouncement = Pick<Announcement, "id" | "title" | "body" | "startTime"> & {
	author: (Pick<User, "id"> & UserNameAndImageFragment) | null;
	mediaAttachments: ArrayPick<Announcement["mediaAttachments"], "isFile" | "fileContentType">;
};

export type AnnouncementCardProps = {
	announcement: CardAnnouncement & AnnouncementModalProps["announcement"];
	isNew?: boolean;
} & Partial<ClassNameProps & StyleProps>;

export function AnnouncementCard({ announcement, isNew, className, style }: AnnouncementCardProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	return (
		<div onClick={openModal} className={makeClassName(styles["announcement-card"], className)} style={style}>
			<Column justify="spaced-start" verticalSpacing="0.5rem">
				<AuthorTimestampView announcement={announcement} isNew={isNew} />

				<If condition={announcement.body !== "" || announcement.mediaAttachments.length > 0}>
					<Row justify="space-between" align="center">
						<TruncatedText className={styles["announcement-card__body-text"]}>{announcement.body}</TruncatedText>
						<If condition={announcement.mediaAttachments.length > 0}>
							<MediaAttachmentComponents.MediaAttachmentsSummary
								mediaAttachments={announcement.mediaAttachments}
								className={styles["announcement-card__attachments"]}
							/>
						</If>
					</Row>
				</If>
			</Column>

			<Modal.If condition={isModalOpen}>
				<AnnouncementModal announcement={announcement} isNew={isNew} onClose={closeModal} />
			</Modal.If>
		</div>
	);
}

type AuthorTimestampViewProps = {
	announcement: Pick<CardAnnouncement, "id" | "startTime" | "author">;
	isNew?: boolean;
} & Partial<ClassNameProps & StyleProps>;

function AuthorTimestampView({ announcement, isNew, className, style }: AuthorTimestampViewProps) {
	return (
		<GeneralAuthorTimestampView
			author={announcement.author}
			timestamp={announcement.startTime}
			isNew={isNew}
			iconSize={35}
			authorClassName={styles["announcement-card__author-name"]}
			timestampClassName={styles["announcement-card__timestamp"]}
			className={className}
			style={style}
		/>
	);
}
